<template>
  <footer
    class="d-flex py-1 justify-content-center justify-content-md-between flex-lg-row align-items-center flex-column text-center text-lg-left"
  >
    <span class="my-25 my-md-0">
      جميع الحقوق محفوظة لوزارة الشؤون الاجتماعية والعمل - الجمهورية العربية
      السورية
      {{ new Date().getFullYear() }}©
    </span>

    <span class=""
      >تمت صناعته بكل حب في ورشة تك

      <feather-icon
        fill="#ea5455"
        icon="HeartIcon"
        size="21"
        class="text-danger"
      />
      <b-link class="ml-50" href="https://warshatec.com/" target="_blank"
        >Warshatec</b-link
      >
    </span>
  </footer>
</template>

<script>
import { BLink } from "bootstrap-vue";

export default {
  components: {
    BLink,
  },
};
</script>
